module.exports = __webpack_public_path__ + "img/sec-7_icon-prock.a02ae337.svg";